module.exports = __webpack_public_path__ + "files/a83fcae129a2ab50415c8983b21ad106.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/roboto-bolditalic-webfont.ttf
// module id = 910
// module chunks = 60